import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AttachmentModalData } from 'src/app/Attachment/attachment.modal.model';
import { CommentModalData } from 'src/app/Comments/comments.service';

export interface ICellRendererParamsForPaymentBatchListGridAction extends ICellRendererParams {
    canEdit: boolean;
    viewDetails: (params: ICellRendererParamsForPaymentBatchListGridAction) => void;
    delete: (params: ICellRendererParamsForPaymentBatchListGridAction) => void;
    canDelete: (params: ICellRendererParamsForPaymentBatchListGridAction) => boolean;
}

@Component({
    selector: 'payment-batch-cc-grid-action-cell',
    template:
        `
        @if (paymentBatch) {
          <button type="button"
            helpTooltip
            helpContentId="app.view"
            position="bottom"
            class="ace-btn btn-primary has-icon grid-action-button"
            (click)="onViewDetailsClicked()">
            <i class="fa fa-pencil"></i>
          </button>
        }
        @if (paymentBatch) {
          <span class="icon-indicator">
            <i class="fa fa-fw"></i>
          </span>
        }
        @if (paymentBatch && paymentBatch.hasComments) {
          <span class="icon-indicator">
            <i class="fa fa-commenting"></i>
          </span>
        }
        @if (paymentBatch && !paymentBatch.hasComments) {
          <span class="icon-indicator">
            <i class="fa fa-fw"></i>
          </span>
        }
        @if (paymentBatch && paymentBatch.hasAttachments) {
          <span class="icon-indicator">
            <i class="fa fa-files-o"></i>
          </span>
        }
        @if (paymentBatch) {
          <entity-comments
            [hasComments]="paymentBatch && paymentBatch.hasComments"
            buttonClass="ace-btn btn-primary has-icon grid-action-button"
            [modalData]="commentModalData"
            helpTooltip
            helpContentId="app.comments"
            position="bottom">
          </entity-comments>
        }
        @if (paymentBatch) {
          <entity-attachments [hasAttachments]="paymentBatch && paymentBatch.hasAttachments"
            buttonClass="ace-btn btn-primary has-icon grid-action-button"
            [modalData]="attachmentModalData"
            helpTooltip
            helpContentId="app.attachments"
            position="bottom">
          </entity-attachments>
        }
        @if (paymentBatch && params.canDelete(params)) {
          <button type="button"
            class="ace-btn has-icon btn-primary btn-danger grid-action-button"
            (click)="onDeleteClicked()"
            helpTooltip
            helpContentId="app.delete"
            position="bottom">
            <i class="fa fa-trash"></i>
          </button>
        }
        `,
    standalone: false
})
export class PaymentBatchListGridActionCellRendererComponent implements ICellRendererAngularComp {
    params: ICellRendererParamsForPaymentBatchListGridAction;
    paymentBatch: Core.PaymentBatchModel;
    attachmentModalData: AttachmentModalData;
    commentModalData: CommentModalData;

    agInit(params: ICellRendererParamsForPaymentBatchListGridAction): void {
        this.params = params;
        this.paymentBatch = params.data as Core.PaymentBatchModel;

        if (!this.paymentBatch) {
            return;
        }
        this.attachmentModalData = {
            entityType: 'PaymentBatch', //todo: make this a constant generated typescript value
            entityName: this.paymentBatch.description,
            disableYears: false,
            singleYear: false,
            entityData: {
                typeId: Core.EntityTypes.PaymentBatch,
                id: this.paymentBatch.paymentBatchId,
                name: this.paymentBatch.description
            },
            readOnly: !this.params.canEdit
        } as AttachmentModalData;

        this.commentModalData = {
            entityID: this.paymentBatch.paymentBatchId,
            entityTypeID: Core.EntityTypes.PaymentBatch,
            entityName: this.paymentBatch.description,
            parcelAcctNum: null,
            canEdit: this.params.canEdit,
            description: null,
            parcelID: null
        } as CommentModalData;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }

    onViewDetailsClicked(): void {
        this.params.viewDetails(this.params);
    }

    onDeleteClicked(): void {
        this.params.delete(this.params);
    }
}
